<template>
  <div style="height: 600px;" class="w-full">
    <l-map
      v-if="showMap"
      ref="myMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 90%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />

      <l-marker v-for="mark in markers" :key="mark.id" :lat-lng="mark.position">
        <l-icon :icon-anchor="[30,30]">
          <icon name="map-marker" class="w-10" :class="iconColor(mark.status)" />
        </l-icon>
        <l-tooltip :options="{ permanent: true, interactive: true }">
          <div @click="innerClick(mark.id)">
            {{ mark.nome }}
          </div>
        </l-tooltip>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { latLng, LatLngBounds } from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from 'vue2-leaflet'
import Icon from '../../Shared/Icon.vue'

export default {
  name: 'Mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    Icon,
  },
  props: {
    prospeccoes: Array,
  },
  data() {
    return {
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
    }
  },
  computed:{
    markers(){
      return this.prospeccoes.map(function (pros){
        const coordenadas = pros.coordenadas.split(',')
        return {
          id: pros.idProspeccao,
          nome: pros.nome,
          status: pros.status,
          reacao: pros.reacao,
          position: latLng(coordenadas[0], coordenadas[1]),
        }
      })
    },
  },
  created(){

    setTimeout(() =>this.$refs.myMap.fitBounds((new LatLngBounds(this.markers.map(row => [row.position.lat, row.position.lng])))), 500)

  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    showLongText() {
      this.showParagraph = !this.showParagraph
    },
    iconColor(status) {
      return {
        'fill-blue-600': status == 'A',
        'fill-orange-600': status == 'N',
        'fill-red-600': status == 'C',
        'fill-green-600': status == 'F',
      }
    },
    innerClick(id) {
      window.open(`/prospeccoes/${id}/edit`, '_blank').focus()
    },
  },
}
</script>
